// @ts-nocheck
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking() {
    const location = useLocation();
    useEffect(() => {
        if (window.gtag) {
            window.gtag("event", "page_view", {
                page_path: location.pathname + location.search,
                page_location: window.location.href,
                page_title: document.title,
            });
            console.log("GA4 page_view sent:", location.pathname + location.search);

        }
    }, [location]);
}
